import React from 'react';
import Layout from '../components/Layout';

const mainOffice = {
  name: 'Dakar City Office',
  tag: 'Headquarters',
  address: 'N 37, Rue, Abdou Karim, Bourgi, Dakar, SENEGAL',
  phones: ['(+221) 78 593 29 13', '(+221) 77 727 85 96'],
  email: 'dakar@bluejay-travels.com',
  flag: '🇸🇳'
};

const otherOffices = [
  {
    name: 'Dakar Airport Office',
    tag: 'Airport Desk',
    address: `Aéroport Blaise Diagne, Départ 3 (à l'intérieur), Dakar, SÉNÉGAL`,
    phones: ['(+221) 77 727 85 96', '(+221) 78 736 48 30'],
    email: 'airportdkr@bluejay-travels.com',
    flag: '🛫'
  },
  {
    name: 'Conakry, Guinea',
    tag: 'Regional Office',
    address: '8eme Avenue Immeuble Transco, Almamya en Face de Lonagui, Conakry, Guinea',
    phones: ['(+224) 669 05 99 15', '(+224) 613 26 98 80'],
    email: 'salescky@bluejay-travels.com',
    flag: '🇬🇳'
  },
  {
    name: 'Abidjan',
    tag: 'Regional Office',
    address: 'Marcory Zone 4, Rue du Alizes, 10 BP 3473',
    phones: ['(+225) 07 198 87 362'],
    email: 'salesabj@shardatravel.com',
    flag: '🇨🇮'
  },
  {
    name: 'Jaipur, India',
    tag: 'India Head Office',
    address: 'B-112 BC-7, Central Spine Yojana, near Akshay Patra Choraha, Jaipur 302023',
    phones: ['+91 9587532127'],
    email: 'salesjai@bluejay-travels.com',
    flag: '🇮🇳'
  }
];

const upcomingOffices = [
  { name: 'Libreville', country: 'Gabon', flag: '🇬🇦' },
  {name:'Dubai', country:'UAE', flag:'🇦🇪'},
  {name:'Douala', country:'Cameroon', flag:'🇨🇲'}
];

function PhoneLink(props) {
  var digits = '';
  for (var i = 0; i < props.phone.length; i++) {
    var c = props.phone[i];
    if (c >= '0' && c <= '9') digits += c;
  }
  return (
    <a
      href={'tel:+' + digits}
      style={{
        display: 'flex', alignItems: 'center', gap: 6,
        fontSize: '0.88rem', fontWeight: 600,
        color: 'var(--bj-clay)', textDecoration: 'none',
        marginBottom: 4
      }}
    >
      📞 {props.phone}
    </a>
  );
}

function OfficeCard(props) {
  var o = props.office;
  var isMain = props.isMain || false;
  var [hovered, setHovered] = React.useState(false);

  return (
    <div
      onMouseEnter={function() { setHovered(true); }}
      onMouseLeave={function() { setHovered(false); }}
      style={{
        background: isMain
          ? 'linear-gradient(135deg, var(--bj-espresso), #1e3f6b)'
          : '#fff',
        color: isMain ? '#fff' : 'var(--bj-espresso)',
        borderRadius: 16,
        padding: '28px 26px',
        boxShadow: hovered
          ? '0 20px 48px rgba(17,45,78,0.18)'
          : '0 6px 24px rgba(17,45,78,0.08)',
        transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        borderLeft: isMain ? 'none' : '4px solid var(--bj-clay)',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {isMain && (
        <div style={{
          position: 'absolute', top: -40, right: -40,
          width: 160, height: 160, borderRadius: '50%',
          background: 'rgba(63,114,175,0.2)', pointerEvents: 'none'
        }} />
      )}

      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
        <span style={{ fontSize: '2rem', flexShrink: 0 }}>{o.flag}</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          {/* Tag */}
          <span style={{
            display: 'inline-block',
            fontSize: '0.68rem', fontWeight: 700,
            letterSpacing: '0.1em', textTransform: 'uppercase',
            padding: '2px 10px', borderRadius: 20, marginBottom: 8,
            background: isMain ? 'rgba(255,255,255,0.15)' : 'var(--bj-sand)',
            color: isMain ? '#fff' : 'var(--bj-clay)'
          }}>
            {o.tag}
          </span>

          <h3 style={{
            margin: '0 0 8px',
            color: isMain ? '#fff' : 'var(--bj-espresso)',
            fontSize: '1.05rem'
          }}>
            {o.name}
          </h3>

          <p style={{
            margin: '0 0 14px',
            fontSize: '0.85rem',
            opacity: isMain ? 0.75 : 0.65,
            lineHeight: 1.6
          }}>
            📍 {o.address}
          </p>

          <div style={{ marginBottom: 10 }}>
            {o.phones.map(function(p) {
              return <PhoneLink key={p} phone={p} />;
            })}
          </div>

          <a
            href={'mailto:' + o.email}
            style={{
              fontSize: '0.88rem', fontWeight: 600,
              color: isMain ? 'var(--bj-sand)' : 'var(--bj-clay)',
              textDecoration: 'none',
              display: 'flex', alignItems: 'center', gap: 6
            }}
          >
            ✉️ {o.email}
          </a>
        </div>
      </div>
    </div>
  );
}

export default function Offices() {
  return (
    <Layout>
      {/* HERO */}
      <div style={{
        background: 'linear-gradient(135deg, var(--bj-espresso) 0%, #1e3f6b 100%)',
        padding: '64px 0 56px', position: 'relative', overflow: 'hidden'
      }}>
        <div style={{ position: 'absolute', top: -60, right: -60, width: 260, height: 260, borderRadius: '50%', background: 'rgba(63,114,175,0.1)', pointerEvents: 'none' }} />
        <div className="container" style={{ position: 'relative' }}>
          <span className="eyebrow" style={{ color: 'var(--bj-sand)' }}>Find Us</span>
          <h1 style={{ color: '#fff', margin: '10px 0 14px', fontSize: 'clamp(1.8rem, 4vw, 2.8rem)' }}>
            Office Locations
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.65)', maxWidth: 520, lineHeight: 1.75, margin: 0 }}>
            Bluejay Travels operates across West Africa and South Asia, with local specialists
            in every office ready to assist you directly.
          </p>

          {/* Quick stats */}
          <div style={{ display: 'flex', gap: 24, marginTop: 28, flexWrap: 'wrap' }}>
            {[
              { number: '5', label: 'Active Offices' },
              { number: '4', label: 'Countries' },
              { number: '2', label: 'Continents' }
            ].map(function(s) {
              return (
                <div key={s.label}>
                  <p style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: '1.8rem', fontWeight: 700, color: '#fff', lineHeight: 1 }}>{s.number}</p>
                  <p style={{ margin: '4px 0 0', fontSize: '0.78rem', color: 'rgba(255,255,255,0.55)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em' }}>{s.label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">

          {/* Main office — full width */}
          <div style={{ marginBottom: 24 }}>
            <OfficeCard office={mainOffice} isMain={true} />
          </div>

          {/* Other offices */}
          <h3 style={{ margin: '36px 0 16px', fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.1em', opacity: 0.45, fontFamily: 'var(--font-body)', fontWeight: 700 }}>
            Other Offices
          </h3>
          {/* Dakar Airport — centred, alone */}
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
            <div style={{ width: '100%', maxWidth: 480 }}>
              <OfficeCard office={otherOffices[0]} />
            </div>
          </div>

          {/* Abidjan, Conakry, Jaipur — three in a row */}
          <div className="offices-bottom-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20, marginBottom: 40 }}>
            {otherOffices.slice(1).map(function(o) {
              return <OfficeCard key={o.name} office={o} />;
            })}
          </div>

          {/* Upcoming */}
          <h3 style={{ margin: '0 0 16px', fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.1em', opacity: 0.45, fontFamily: 'var(--font-body)', fontWeight: 700 }}>
            Upcoming Offices
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 14 }}>
            {upcomingOffices.map(function(o) {
              return (
                <div key={o.name} style={{
                  display: 'flex', alignItems: 'center', gap: 14,
                  padding: '18px 20px',
                  borderRadius: 12,
                  border: '2px dashed var(--bj-sand)',
                  background: 'var(--bj-cream-soft)'
                }}>
                  <span style={{ fontSize: '1.6rem' }}>{o.flag}</span>
                  <div>
                    <p style={{ margin: 0, fontWeight: 700, fontSize: '0.95rem' }}>{o.name}</p>
                    <p style={{ margin: '2px 0 0', fontSize: '0.78rem', opacity: 0.55 }}>{o.country}</p>
                    <span style={{
                      display: 'inline-block', marginTop: 4,
                      fontSize: '0.65rem', fontWeight: 700,
                      letterSpacing: '0.1em', textTransform: 'uppercase',
                      color: 'var(--bj-clay)'
                    }}>Coming Soon</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </Layout>
  );
}